export default __webpack_public_path__ + "c5c02d763c89380dcb4ed359e15d0897.ttf";